import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";
import Logo from "@/components/brand/Logo";

const LINKS = [
    { label: "Product", to: "#product" },
    { label: "YugOS Intelligence", to: "#brain" },
    { label: "Flow", to: "#flow" },
    { label: "Story", to: "#story" },
];

export default function Nav() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 ${
                scrolled
                    ? "bg-[#f7f3ec]/80 backdrop-blur-xl border-b border-[#1c1917]/[0.07]"
                    : "bg-transparent border-b border-transparent"
            }`}
            data-testid="landing-nav"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8 flex items-center h-14 sm:h-16">
                <Link to="/" className="flex items-center gap-2 sm:gap-2.5 min-w-0" data-testid="landing-logo">
                    <Logo size={28} />
                    <span className="font-display text-[15px] sm:text-[16px] font-bold tracking-tight text-[#1c1917]">
                        YugOS
                    </span>
                    <span className="hidden sm:inline-flex rounded-full border border-[#1c1917]/15 px-2 py-0.5 text-[9px] font-mono uppercase tracking-[0.18em] text-[#59524a]">
                        v0.1
                    </span>
                </Link>
                <nav className="hidden md:flex items-center gap-8 ml-12">
                    {LINKS.map((l) => (
                        <a
                            key={l.to}
                            href={l.to}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-[13px] font-medium text-[#59524a] hover:text-[#1c1917] transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div className="ml-auto flex items-center gap-2 sm:gap-3">
                    <Link to="/login" data-testid="landing-launch-btn">
                        <span className="group inline-flex h-9 items-center gap-1.5 rounded-full bg-[#1c1917] pl-3.5 sm:pl-4 pr-3 sm:pr-3.5 text-[12.5px] sm:text-[13px] font-medium text-[#f7f3ec] transition-colors hover:bg-[#33302b]">
                            <span className="hidden xs:inline">Launch </span>YugOS
                            <ArrowUpRight
                                className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                                strokeWidth={2}
                            />
                        </span>
                    </Link>
                    <button
                        className="md:hidden rounded-full border border-[#1c1917]/15 p-2"
                        onClick={() => setOpen(!open)}
                        data-testid="landing-mobile-toggle"
                        aria-label="Toggle menu"
                    >
                        {open ? (
                            <X className="h-4 w-4" strokeWidth={1.5} />
                        ) : (
                            <Menu className="h-4 w-4" strokeWidth={1.5} />
                        )}
                    </button>
                </div>
            </div>
            {open && (
                <div className="md:hidden border-t border-[#1c1917]/[0.07] bg-[#f7f3ec]/95 backdrop-blur-xl">
                    <div className="mx-auto max-w-7xl px-5 sm:px-6 py-3 flex flex-col gap-1">
                        {LINKS.map((l) => (
                            <a
                                key={l.to}
                                href={l.to}
                                onClick={() => setOpen(false)}
                                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="text-[14.5px] font-medium text-[#33302b] py-2.5"
                            >
                                {l.label}
                            </a>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
}
